<div class="mt-5">
    <div class="d-flex justify-content-center">
        <div class="card col-12 col-lg-5">
            <main class="form-signin">
                <form [formGroup]="loginForm" (ngSubmit)="login()" autocomplete="off">
                    <div class="text-center mb-4">
                        <h3 class="mb-3 font-weight-normal">Sign in</h3>
                    </div>
                    <div class="form-floating mb-3">
                        <input formControlName="userName" type="text" placeholder="Username (your email address)"
                            class="form-control" [class.is-invalid]="submitted && loginForm.get('userName')?.errors">
                        <label for="userName">Username (your email address)</label>
                        <span class="text-danger" *ngIf="submitted && loginForm.get('userName')?.hasError('required')">
                            Username is required
                        </span>
                    </div>

                    <div class="form-floating mb-3">
                        <input formControlName="password" type="password" placeholder="Password" class="form-control"
                            [class.is-invalid]="submitted && loginForm.get('userName')?.errors">
                        <label for="password">Password</label>
                        <span class="text-danger" *ngIf="submitted && loginForm.get('password')?.hasError('required')">
                            Password is required
                        </span>
                    </div>

                    <div class="form-floatin" *ngIf="errorMessages.length > 0">
                        <identity-validation-messages [errorMessages]="errorMessages"></identity-validation-messages>
                        <a class="btn btn-link" (click)="resendEmailConfirmationLink()"
                            *ngIf="errorMessages[0].includes('Please confirm your email')">
                            Click here to resend email confirmation link in case you didn't receive it.
                        </a>
                    </div>

                    <div class="d-grid mt-4 px-1">
                        <button class="btn btn-lg btn-info" type="submit">Log in</button>
                    </div>
                </form>

                <div class="mt-4 text-center">
                    <a class="btn btn-link" routerLink="/account/send-email/forgot-username-or-password">
                        <h6>Forgot username or password</h6>
                    </a>
                </div>

                <div class="row d-flex justify-content-center mt-3">
                    <div class="col-5">
                        <hr>
                    </div>
                    <div class="col-2 text-center">OR</div>
                    <div class="col-5">
                        <hr>
                    </div>
                </div>
                <div class="d-flex justify-content-between my-3">
                    <div #googleButton></div>
                    <button style="width: 180px;" class="btn btn-primary btn-sm" (click)="loginWithFacebook()">
                        Facebook
                    </button>
                </div>
                <p class="font-monospace fw-medium text-center text-muted mt-2 mb-0">
                    Don't have an account yet? <a routerLink="/account/register" class="text-decoration-none">Create
                        account</a>
                </p>
            </main>
        </div>
    </div>
    </div>